/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxGamesLibWebRpcContractsResponseFromJSON, FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsToJSON, } from '../models/index';
/**
 *
 */
export class PushTokensApi extends runtime.BaseAPI {
    /**
     * **MUTATES:** `pushtoken`  Saves push token
     */
    async fxIdWebFeaturesPushTokensSavePushTokenEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs'] == null) {
            throw new runtime.RequiredError('fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs', 'Required parameter "fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs" was null or undefined when calling fxIdWebFeaturesPushTokensSavePushTokenEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/push_tokens/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationPushNotificationsTokensSaveSavePushTokenArgsToJSON(requestParameters['fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `pushtoken`  Saves push token
     */
    async fxIdWebFeaturesPushTokensSavePushTokenEndpoint(fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs, initOverrides) {
        const response = await this.fxIdWebFeaturesPushTokensSavePushTokenEndpointRaw({ fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs: fxIdApplicationPushNotificationsTokensSaveSavePushTokenArgs }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=PushTokensApi.js.map